export default __webpack_public_path__ + "static/media/ods10.d1e68ef5.svg";